<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Subject Teacher Mapping
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv()" persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-btn class="mt-6 button" @click="getTeacherList()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="6" sm="2" md="2">
                    <v-btn class="ma-2 no-display " rounded color="success" outlined v-if="crs_list != null"
                        @click="fnExcelReport('my-table-id', 'SubjectTeacherMapping')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col sm="2" v-if="previousAyList && previousAyList.length > 0">
                    <v-btn class="mt-6 button" @click="copyDialog = true">Fetch from Previous AY</v-btn>
                </v-col>
            </v-row>
            <span v-if="crs_list != null">
                <div id="my-table-id">
                    <v-data-table v-if="crs_list!=null" dense :headers="headers1" :items="crs_list" :search="search"
                        class="elevation-1" :items-per-page="-1">
                        <template v-slot:item.options="{ item }">
                            <v-row class="pt-1 m-0">
                                    <v-autocomplete class="pr-2" dense required outlined rounded color="#0F2027" v-model="item.inst"
                                        :items="inst_list" item-text="inst_name" return-object label="Select Teacher" />

                                        <v-autocomplete v-if="add_alternate_teacher_flag" dense required outlined rounded color="#0F2027" v-model="item.alternate_inst"
                                        :items="inst_list" item-text="inst_name" return-object label="Select Alternate Teacher" />

                                    <v-btn rounded class="button" small
                                        @click="setteacher(item.std_id, item.crs_id, item.inst.inst_id, item.ay_id, item.div_id,item.alternate_inst)">Apply</v-btn>
                              
                            </v-row>
                        </template>
                    </v-data-table>
                </div>
                <v-row v-if="crs_list!=null" align="center" justify="center">
                    <v-btn dense outlined rounded class="button" @click="save(crs_list)">Assign To All</v-btn>
                </v-row>
            </span>

        </v-card>
        <v-dialog v-model="copyDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Fetch from Previous Academic Year
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col sm="12">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="copy_from_ay" return-object
                        :items="previousAyList" item-text="name" label="Academic Year" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer> </v-spacer>                    
                    <v-btn color="primary" @click="getTeacherList">Fetch</v-btn>
                    <v-btn color="primary" text @click="copyDialog = false" outlined>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            search: "",
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            copyDialog: false,
            copy_from_ay: null,
            previousAyList : [],
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            inst_list: null,
            crs_list: null,
            add_alternate_teacher_flag:null,
            headers1: [
                {
                    text: "Sr. No.",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Academic Year",
                    align: "center",
                    sortable: false,
                    value: "ay",
                },
                {
                    text: "Standard",
                    align: "center",
                    sortable: false,
                    value: "std",
                },
                {
                    text: "Division",
                    align: "center",
                    sortable: false,
                    value: "div",
                },
                {
                    text: "Course",
                    align: "center",
                    sortable: false,
                    value: "crs_name",
                },
                {
                    text: "Current Set Teacher",
                    align: "center",
                    sortable: false,
                    value: "current_inst_name",
                },
                {
                    text: "Teacher",
                    align: "center",
                    sortable: false,
                    value: "options",
                },
            ],
        };
    },
    methods: {
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Division</th>
     <th>Course</th>
     <th>Current Set Teacher</th>
    </tr>`;

  this.crs_list.forEach((item, index) => {
    tab_text += `
    <tr>
            <td>${index + 1 || ''}</td>
            <td>${item.ay || ''}</td>
            <td>${item.std || ''}</td>
            <td>${item.div || ''}</td>
            <td>${item.crs_name || ''}</td>
            <td>${item.inst_name || ''}</td>
        </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
        getStd() {
            // this.std_div_list = ["All"];
            // this.sel_std_data = "All";
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
            this.std_div_list = this.sel_ay_data.std_list;
            // this.std_div_list.unshift("All");
            // this.sel_std_data = this.std_div_list[0];
        },
        getDiv() {
            // this.div_list = ["All"];
            // this.div = "All";
            this.div_list = null;
            this.div = null;
            this.div_list = this.sel_std_data.div_list;
            // this.div_list.unshift("All");
            // this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        getTeacherList() {
            // let ay = null;
            // if(this.copyDialog){
            //     ay = this.copy_from_ay.id;
            // }else{
            //     ay= this.sel_ay_data.ay_id;
            // }
            //this.crs_list = null
            this.inst_list = null
            const data = {
                isCopy : this.copyDialog,
                ay: this.sel_ay_data.ay_id,
                prevay : this.copy_from_ay ? this.copy_from_ay.id : null,
                standard: this.sel_std_data.std_id,
                division: this.div.div_off_id,
            };
            this.overlay = true;
            axios
                .post("/Examination/getAssignedTeachers", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.crs_list = res.data.crs_list
                        this.inst_list = res.data.inst_list
                        this.inst_list.unshift("NA");
                        this.previousAyList = res.data.previousAYList;
                        this.add_alternate_teacher_flag = res.data.add_alternate_teacher_flag
                        //this.div = this.div_list[0];
                    }
                })
                .catch((error) => {
                    this.overlay = true;
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    "use strict";
                    this.overlay = false;
                    this.copyDialog = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        setteacher(std_id, crs_id, inst, ay_id, div_id,alternate_inst) {
            const data = {
                ay: ay_id,
                standard: std_id,
                division: div_id,
                crs_id: crs_id,
                inst_id: inst,
                alternate_inst:alternate_inst
            };
            this.overlay = true;
            axios
                .post("/Examination/assignedTeachers", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Teacher Assigned successfully");
                        this.getTeacherList()
                      //  this.onload()
                    }
                    if (res.data.flag == "NO") {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    "use strict";
                    this.overlay = false;
                  //  this.crs_list = null
                });
        },
        save(crs_list) {
            const data = {
                crs_list: crs_list
            }
            this.overlay = true;
            axios
                .post("/Examination/assignedAllTeachers", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Teacher Assigned successfully");
                        this.getTeacherList()
                     //   this.onload()
                    }
                })
                .catch((error) => {
                    this.overlay = true;
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    "use strict";
                    this.overlay = false;
                    //this.crs_list = null
                });
        },
        onload() {
          //  this.crs_list = null
            //this.uid = localStorage.getItem("EPS-uid")
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.sel_ay_data = res.data.curr_ay;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                });
        }
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped>
.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>

